import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"

import timezones from "./timezone.json"
import { Select } from "components"

const TimezoneSelect = props => {
  const { value, ...otherProps } = props

  const [t] = useTranslation()

  const options = useMemo(() => (
    timezones.map(timezone => ({
      label: timezone.text,
      value: timezone.utc[1] || timezone.utc[0]
    }))
  ), [])

  const selectedTimezone = useMemo(() => {
    const targetTimzone =
      timezones.find(timezone =>
        timezone.utc.includes(value)
      )

    if (!targetTimzone) return null

    return {
      label: targetTimzone.text,
      value: targetTimzone.utc[1] || targetTimzone.utc[0]
    }
  }, [value])

  return (
    <Select
      label={t("روش_ارسال_زمانی")}
      placeholder={t("جست_و_جوی_روش_ارسال_زمانی")}
      options={options}
      value={selectedTimezone}
      {...otherProps}
    />
  )
}

export default TimezoneSelect